<div class="fill-parent display-flex flex-col">
  <div class="report-head" *ngIf="report == 0 && !useTabs">
    <div class="report-back">
    <div class="report-title detail-page-title margin-l-l">
    </div>

  <div class="report-date">
    <mat-form-field  class="report-picker" appearance="outline" style="width: 150px; height: 50px;">
    <input matInput [matDatepicker]="startDatePicker" style="width: 100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
    <mat-datepicker-toggle matPrefix [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field   class="report-picker" appearance="outline" style="width: 150px; height: 50px; margin-left: 4px;">
    <input matInput [matDatepicker]="endDatePicker" style="width: 100px;" placeholder="End Date" [(ngModel)]="endDate">
    <mat-datepicker-toggle matPrefix [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker  #endDatePicker></mat-datepicker>
    </mat-form-field>

  </div>
  </div>
  </div>
<!-- Tabbed view for projectId==25 -->
<div *ngIf="report == 0 && useTabs">
  <mat-tab-group class="fill-parent" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabIndexChange($event)">
    <mat-tab label="Learning Analytics">
      <!-- Date controls only for Learning Analytics tab -->
      <div class="report-date" style="padding: 8px 12px 0 12px; display: flex;">
        <mat-form-field class="report-picker" appearance="outline" style="width: 150px; height: 50px;">
          <input matInput [matDatepicker]="startDatePickerLA" style="width: 100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerLA"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerLA></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="report-picker" appearance="outline" style="width: 150px; height: 50px; margin-left: 4px;">
          <input matInput [matDatepicker]="endDatePickerLA" style="width: 100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerLA"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerLA></mat-datepicker>
        </mat-form-field>
      </div>
      <ng-scrollbar class="fill-parent projects-details-tab">
        <div class="flex-grow-1 display-flex flex-col">
          <div class="display-grid projects-grid">
            <div class="project-item" *ngFor="let item of generalReports" (click)="selectReport(item.id)" (keydown.enter)="selectReport(item.id)">
              <div *ngIf="item.id == 1">
                <devices-synched-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 200]" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></devices-synched-report>
              </div>
              <div *ngIf="item.id == 3">
                <app-utilization-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[270, 200]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></app-utilization-report>
              </div>
              <div class="flex-grow-1" *ngIf="item.id == 2">
                <title-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 180]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></title-report>
              </div>
              <div class="flex-grow-1" *ngIf="item.id == 4">
                <subject-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 200]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></subject-report>
              </div>
              <div class="flex-grow-1" *ngIf="item.id == 5">
                <time-used-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 182]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></time-used-report>
              </div>
              <div class="flex-grow-1" *ngIf="item.id == 6" style="height: 200px;">
                <util-grid-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 200]" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></util-grid-report>
              </div>
              <div class="project-title margin-t-l" [ngStyle]="item.id == 6? {'margin-top':'36px'} : {'margin-top':'16px'}">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </mat-tab>
    <mat-tab label="MCF Learning Analytics">
      <ng-template matTabContent>
      <!-- Shared date range controls for MCF Learning Analytics -->
      <div class="report-date" style="padding: 8px 12px 0 12px; display: flex; justify-content: flex-end;">
        <mat-form-field class="report-picker" appearance="outline" style="width: 150px; height: 50px; margin-right: 4px;">
          <input matInput [matDatepicker]="startDatePickerMCF" style="width: 100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerMCF"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerMCF></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="report-picker" appearance="outline" style="width: 150px; height: 50px;">
          <input matInput [matDatepicker]="endDatePickerMCF" style="width: 100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerMCF"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerMCF></mat-datepicker>
        </mat-form-field>
      </div>
      <ng-scrollbar class="fill-parent projects-details-tab">
        <div class="flex-grow-1 display-flex flex-col">
          <div class="display-grid projects-grid">
              <div class="project-item" *ngFor="let item of mcfReports" (click)="selectReport(item.id)">
              <div class="flex-grow-1" *ngIf="item.id == 8" style="height: 200px;">
                <app-learner-performance (backEvent)="back()" [viewsize]="mcfTileView" [disableResize]="true" [startDate]="startDate" [endDate]="endDate"></app-learner-performance>
              </div>
              <div class="flex-grow-1" *ngIf="item.id == 9" style="height: 200px;">
                <app-most-watched (backEvent)="back()" [viewsize]="mcfTileView" [disableResize]="true" [useStacked]="true" [startDate]="startDate" [endDate]="endDate"></app-most-watched>
              </div>
              <div class="flex-grow-1" *ngIf="item.id == 10" style="height: 200px;">
                <app-most-watched-by-theme (backEvent)="back()" [viewsize]="mcfTileView" [disableResize]="true" [tileMode]="true" [startDate]="startDate" [endDate]="endDate"></app-most-watched-by-theme>
              </div>
              <div class="flex-grow-1" *ngIf="item.id == 11" style="height: 200px;">
                <app-pp2-vocab-quiz-report [viewsize]="mcfTileView" [disableResize]="true" [startDate]="startDate" [endDate]="endDate"></app-pp2-vocab-quiz-report>
              </div>
              <div class="project-title margin-t-l" [ngStyle]="item.id == 6? {'margin-top':'36px'} : {'margin-top':'16px'}">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
      </ng-template>
    </mat-tab>
    <mat-tab label="YouTube Analytics" *ngIf="useTabs">
      <ng-template matTabContent>
        <!-- Shared date range controls for YouTube Analytics -->
        <div class="report-date" style="padding: 8px 12px 0 12px; display: flex; justify-content: flex-end;">
          <mat-form-field class="report-picker" appearance="outline" style="width: 150px; height: 50px; margin-right: 4px;">
            <input matInput [matDatepicker]="startDatePickerYT" style="width: 100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
            <mat-datepicker-toggle matPrefix [for]="startDatePickerYT"></mat-datepicker-toggle>
            <mat-datepicker #startDatePickerYT></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="report-picker" appearance="outline" style="width: 150px; height: 50px;">
            <input matInput [matDatepicker]="endDatePickerYT" style="width: 100px;" placeholder="End Date" [(ngModel)]="endDate">
            <mat-datepicker-toggle matPrefix [for]="endDatePickerYT"></mat-datepicker-toggle>
            <mat-datepicker #endDatePickerYT></mat-datepicker>
          </mat-form-field>
        </div>
        <ng-scrollbar class="fill-parent projects-details-tab">
          <div class="flex-grow-1 display-flex flex-col">
            <div class="display-grid projects-grid">
              <div class="project-item" *ngFor="let item of youtubeReports" (click)="selectReport(item.id)" (keydown.enter)="selectReport(item.id)">
                <div class="flex-grow-1" *ngIf="item.id == 12" style="height: 200px;">
                  <app-youtube-video-views (backEvent)="back()" [viewsize]="mcfTileView" [disableResize]="true" [startDate]="startDate" [endDate]="endDate"></app-youtube-video-views>
                </div>
                <div class="flex-grow-1" *ngIf="item.id == 13" style="height: 200px;">
                  <app-youtube-category-views (backEvent)="back()" [viewsize]="mcfTileView" [disableResize]="true" [startDate]="startDate" [endDate]="endDate"></app-youtube-category-views>
                </div>
                <div class="project-title margin-t-l" [ngStyle]="item.id == 6? {'margin-top':'36px'} : {'margin-top':'16px'}">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </ng-scrollbar>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Single grid view for other projects -->
<ng-scrollbar class="fill-parent projects-details-tab" *ngIf="report == 0 && !useTabs">
  <div class="flex-grow-1 display-flex flex-col">
    <div class="display-grid projects-grid">
      <div class="project-item" *ngFor="let item of generalReports" (click)="selectReport(item.id)">
        <div *ngIf="item.id == 1">
          <devices-synched-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 200]" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></devices-synched-report>
        </div>
        <div *ngIf="item.id == 3">
          <app-utilization-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[270, 200]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></app-utilization-report>
        </div>
        <div class="flex-grow-1" *ngIf="item.id == 2">
          <title-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 180]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></title-report>
        </div>
        <div class="flex-grow-1" *ngIf="item.id == 4">
          <subject-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 200]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></subject-report>
        </div>
        <div class="flex-grow-1" *ngIf="item.id == 5">
          <time-used-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 182]" [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></time-used-report>
        </div>
        <div class="flex-grow-1" *ngIf="item.id == 6" style="height: 200px;">
          <util-grid-report [outstartDate]="startDate!" [outendDate]="endDate!" [isout]="true" [viewsize]="[350, 200]" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></util-grid-report>
        </div>
        <div class="project-title margin-t-l" [ngStyle]="item.id == 6? {'margin-top':'36px'} : {'margin-top':'16px'}">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</ng-scrollbar>
  <div class="flex-grow-1" *ngIf="report == 1">
    <devices-synched-report [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()" ></devices-synched-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 3">
    <app-utilization-report [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></app-utilization-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 2">
    <title-report [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!"  (backEvent)="back()"></title-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 4">
    <subject-report [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!"  (backEvent)="back()"></subject-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 5">
    <time-used-report [deviceId]="deviceId!" [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></time-used-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 6" >
    <util-grid-report [schoolId]="schoolId!" [projectId]="projectId!" (backEvent)="back()"></util-grid-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 7">
    <util-device-report [schoolId]="schoolId!" (backEvent)="back()"></util-device-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 8">
    <div class="report-head">
      <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="back()"><img src="/assets/images/back.svg" alt="Back" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">{{ getReportTitle() }}</div>
      <div class="report-date" style="margin-left:auto; display:flex;">
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px; margin-right:4px;">
          <input matInput [matDatepicker]="startDatePickerDetail8" style="width:100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerDetail8"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerDetail8></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px;">
          <input matInput [matDatepicker]="endDatePickerDetail8" style="width:100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerDetail8"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerDetail8></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <app-learner-performance (backEvent)="back()" [startDate]="startDate" [endDate]="endDate"></app-learner-performance>
  </div>
  <div class="flex-grow-1" *ngIf="report == 9">
    <div class="report-head">
      <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="back()"><img src="/assets/images/back.svg" alt="Back" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">{{ getReportTitle() }}</div>
      <div class="report-date" style="margin-left:auto; display:flex;">
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px; margin-right:4px;">
          <input matInput [matDatepicker]="startDatePickerDetail9" style="width:100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerDetail9"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerDetail9></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px;">
          <input matInput [matDatepicker]="endDatePickerDetail9" style="width:100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerDetail9"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerDetail9></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <app-most-watched (backEvent)="back()" [useStacked]="true" [startDate]="startDate" [endDate]="endDate"></app-most-watched>
  </div>
  <div class="flex-grow-1" *ngIf="report == 10">
    <div class="report-head">
      <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="back()"><img src="/assets/images/back.svg" alt="Back" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">{{ getReportTitle() }}</div>
      <div class="report-date" style="margin-left:auto; display:flex;">
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px; margin-right:4px;">
          <input matInput [matDatepicker]="startDatePickerDetail10" style="width:100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerDetail10"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerDetail10></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px;">
          <input matInput [matDatepicker]="endDatePickerDetail10" style="width:100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerDetail10"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerDetail10></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <app-most-watched-by-theme (backEvent)="back()" [startDate]="startDate" [endDate]="endDate"></app-most-watched-by-theme>
  </div>
  <div class="flex-grow-1" *ngIf="report == 11">
    <div class="report-head">
      <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="back()"><img src="/assets/images/back.svg" alt="Back" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">{{ getReportTitle() }}</div>
      <div class="report-date" style="margin-left:auto; display:flex;">
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px; margin-right:4px;">
          <input matInput [matDatepicker]="startDatePickerDetail11" style="width:100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerDetail11"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerDetail11></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px;">
          <input matInput [matDatepicker]="endDatePickerDetail11" style="width:100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerDetail11"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerDetail11></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <app-pp2-vocab-quiz-report [startDate]="startDate" [endDate]="endDate"></app-pp2-vocab-quiz-report>
  </div>
  <div class="flex-grow-1" *ngIf="report == 12">
    <div class="report-head">
      <div class="report-back">
<button class="main-btn empty-back-btn" (click)="back()"><img src="/assets/images/back.svg" alt="Back" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">{{ getReportTitle() }}</div>
      <div class="report-date" style="margin-left:auto; display:flex;">
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px; margin-right:4px;">
          <input matInput [matDatepicker]="startDatePickerDetail12" style="width:100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerDetail12"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerDetail12></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px;">
          <input matInput [matDatepicker]="endDatePickerDetail12" style="width:100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerDetail12"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerDetail12></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <app-youtube-video-views [startDate]="startDate" [endDate]="endDate"></app-youtube-video-views>
  </div>
  <div class="flex-grow-1" *ngIf="report == 13">
    <div class="report-head">
      <div class="report-back">
<button class="main-btn empty-back-btn" (click)="back()"><img src="/assets/images/back.svg" alt="Back" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">{{ getReportTitle() }}</div>
      <div class="report-date" style="margin-left:auto; display:flex;">
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px; margin-right:4px;">
          <input matInput [matDatepicker]="startDatePickerDetail13" style="width:100px;" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onStartDateChange($event)">
          <mat-datepicker-toggle matPrefix [for]="startDatePickerDetail13"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerDetail13></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="report-picker" appearance="outline" style="width:150px; height:50px;">
          <input matInput [matDatepicker]="endDatePickerDetail13" style="width:100px;" placeholder="End Date" [(ngModel)]="endDate">
          <mat-datepicker-toggle matPrefix [for]="endDatePickerDetail13"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerDetail13></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <app-youtube-category-views [startDate]="startDate" [endDate]="endDate"></app-youtube-category-views>
  </div>
</div>
